<template>
  <div>
    <h1 class="c-heading-1">Resultaten</h1>
    <p>Je hebt nu de verschillende trends doorlopen die op jouw bedrijf van toepassing zijn.</p>
    <p>Onderstaande feedback is een korte herhaling van wat je reeds als voorlopig advies kreeg bij de beëindiging van elke trend. We zetten je uitkomst voor de verschillende trends nog even op een rijtje.</p>
    <ul class="c-results">
      <li class="c-results__item" v-for="result in results" :key="result.id">
        <advice-view
          :status="result.readyForTopic"
          :sizeCategory="result.sizeCategory"
          :no-opinion="result.noOpinion"
          :topic="result.topic"
        />
      </li>
    </ul>
    <alert-box v-if="numberOfColleagues === 0" class="c-colleagues">
      <p>Innoveren doe je niet alleen. Zet een eerste stap. Maak er een teamoefening van en nodig meteen je collega’s of collega-ondernemers uit om ook de scan te doorlopen.</p>
      <p><strong>Stuur een uitnodiging naar volgende e-mailadressen (druk op Enter om een nieuw adres toe te voegen):</strong></p>
      <input-tag
        :tags.sync="colleagues"
        validate="email"
        :add-tag-on-blur="true"
      />
    </alert-box>
    <p>Misschien krijg je goed nieuws en ben je al goed op weg, misschien krijg je ander nieuws en kan je nog wel wat stappen zetten op de weg naar innovatie. De adviesteksten in de scan geven weliswaar enkel een richting aan. Maar welke is de volgende stap?</p>
    <div class="c-toolbar">
      <div class="c-toolbar__right">
        <navigation-button to="/infocoaching" @click="setColleagues">Zet de volgende stap</navigation-button>
      </div>
    </div>
  </div>
</template>

<script>
import AdviceView from '../components/AdviceView.vue'
import AlertBox from '../components/AlertBox'
import InputTag from 'vue-input-tag'
import NavigationButton from '../components/NavigationButton.vue'
export default {
  components: {
    AdviceView,
    AlertBox,
    InputTag,
    NavigationButton
  },
  data () {
    return {
      colleagues: []
    }
  },
  computed: {
    results () {
      const scores = this.$store.getters.scores
      const topics = this.$store.state.topics

      // Convert topics with results to array
      let scoresArray = []
      for (let key in scores) {
        if (scores.hasOwnProperty(key) && scores[key].topicHasResults === true) {
          scoresArray.push({
            ...scores[key],
            topic: topics[key],
            id: key
          })
        }
      }

      // Sort by size category
      scoresArray = scoresArray.sort((scoreA, scoreB) => {
        const categoryA = scoreA.sizeCategory || 0
        const categoryB = scoreB.sizeCategory || 0
        return categoryB - categoryA
      })

      return scoresArray
    },
    numberOfColleagues () {
      return this.$store.state.colleagues.length
    }
  },
  methods: {
    setColleagues () {
      if (this.$store.state.colleagues.length === 0) {
        this.$store.commit('updateColleagues', this.colleagues);
        this.$store.dispatch('updateDatabaseRecord')
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables.scss';

.c-results {
  margin: 3.2rem 0;
}

.c-results__item {
  display: block;

  & + & {
    border-top: 1px solid rgba(#FFF, 0.2);
    margin-top: 2.4rem;
    padding-top: 2.4rem;
  }
}

.c-colleagues {
  margin-top: 2rem;
}

.c-advice__title {
  color: #8997FF;
}
</style>
